
import {
  orderSelection
} from '@/api/materialSelection'

const state = {
}

const mutations = {
}

const actions = {
  // A-21-我的选材单
  orderSelection(temp, data) {
    return new Promise((resolve, reject) => {
      orderSelection(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
